/* ============================================================
   REHYPED NYC — theme scripts
   Products are rendered by Liquid; this handles behaviour only.
   ============================================================ */
(function () {
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const CFG = window.REHYPED || { store: {}, game: {} };

  /* ---------- toast ---------- */
  function toast(msg) {
    const t = $("#toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(t._t);
    t._t = setTimeout(() => t.classList.remove("show"), 2400);
  }

  /* ---------- logo swap ---------- */
  $$(".logo-img").forEach(img => {
    const done = () => { if (img.naturalWidth > 0) img.closest(".logo").classList.add("has-img"); };
    img.complete ? done() : (img.onload = done);
  });

  /* ---------- header + drawer ---------- */
  const hdr = $("#hdr");
  if (hdr) addEventListener("scroll", () => hdr.classList.toggle("scrolled", scrollY > 12), { passive: true });
  const drawer = $("#drawer");
  // lock the page behind the drawer, or iOS scrolls the body instead of the menu
  let scrollY = 0;
  const openDrawer = () => {
    scrollY = window.scrollY;
    drawer.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = "100%";
  };
  const closeDrawer = () => {
    drawer.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    window.scrollTo(0, scrollY);
  };
  $("#burger")?.addEventListener("click", openDrawer);
  $("#closeDrawer")?.addEventListener("click", closeDrawer);
  addEventListener("keydown", e => { if (e.key === "Escape" && drawer?.classList.contains("open")) closeDrawer(); });
  // let a tapped link navigate, but release the lock first
  drawer?.addEventListener("click", e => { if (e.target.closest("a")) closeDrawer(); });

  /* ---------- brand dropdown ---------- */
  $$(".dd").forEach(dd => {
    const toggle = $(".dd-toggle", dd);
    const close = () => { dd.dataset.open = "false"; toggle.setAttribute("aria-expanded", "false"); };
    toggle?.addEventListener("click", e => {
      e.stopPropagation();
      const open = dd.dataset.open === "true";
      dd.dataset.open = open ? "false" : "true";
      toggle.setAttribute("aria-expanded", String(!open));
    });
    document.addEventListener("click", close);
    addEventListener("keydown", e => { if (e.key === "Escape") close(); });
  });

  /* ---------- carousel arrows + progress ---------- */
  const ICON_L = `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 5l-7 7 7 7"/></svg>`;
  const ICON_R = `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 5l7 7-7 7"/></svg>`;
  $$(".car-btn.prev").forEach(b => { if (!b.innerHTML.trim()) b.innerHTML = ICON_L; });
  $$(".car-btn.next").forEach(b => { if (!b.innerHTML.trim()) b.innerHTML = ICON_R; });

  function wireRail(scope, railSel, barSel) {
    const rail = $(railSel, scope), bar = $(barSel, scope);
    if (!rail) return;
    const head = scope.closest("section") || document;
    const prev = $(".car-btn.prev", head), next = $(".car-btn.next", head);
    const step = () => {
      const c = rail.firstElementChild;
      return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0) : 320;
    };
    const sync = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      const ratio = Math.min(Math.max(rail.clientWidth / rail.scrollWidth, 0.1), 1);
      if (bar) {
        bar.style.width = ratio * 100 + "%";
        bar.style.transform = `translateX(${max > 0 ? (rail.scrollLeft / max) * (100 / ratio - 100) : 0}%)`;
      }
      if (prev) prev.disabled = rail.scrollLeft < 4;
      if (next) next.disabled = rail.scrollLeft > max - 4;
    };
    prev?.addEventListener("click", () => rail.scrollBy({ left: -step() * 2, behavior: "smooth" }));
    next?.addEventListener("click", () => rail.scrollBy({ left: step() * 2, behavior: "smooth" }));
    rail.addEventListener("scroll", sync, { passive: true });
    addEventListener("resize", sync);
    sync();
    return { rail, sync, step };
  }

  $$("[data-rail]").forEach(el => wireRail(el, ".rail", ".progress i"));

  /* ---------- instagram slideshow ---------- */
  $$("[data-ig]").forEach(el => {
    const api = wireRail(el, ".ig-rail", ".ig-progress i");
    if (!api) return;
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    let timer = null;
    const tick = () => {
      const max = api.rail.scrollWidth - api.rail.clientWidth;
      api.rail.scrollTo({ left: api.rail.scrollLeft >= max - 4 ? 0 : api.rail.scrollLeft + api.step(), behavior: "smooth" });
    };
    const start = () => { if (!timer) timer = setInterval(tick, 5200); };
    const stop  = () => { clearInterval(timer); timer = null; };
    el.addEventListener("mouseenter", stop);
    el.addEventListener("mouseleave", start);
    new IntersectionObserver(e => e[0].isIntersecting ? start() : stop(), { threshold: 0.25 }).observe(el);
  });

  /* ---------- hero video ---------- */
  const hv = $(".hero-media video");
  if (hv && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
    const play = () => { const p = hv.play(); if (p && p.catch) p.catch(() => {}); };
    play();
    hv.addEventListener("canplay", play);
    addEventListener("pageshow", play);
    document.addEventListener("visibilitychange", () => { if (!document.hidden) play(); });
  }

  /* ---------- product gallery ---------- */
  /* ---------- product gallery + lightbox ---------- */
  const hero = $("#pdpHero");
  if (hero) {
    const thumbs = $$(".pdp-thumb");
    // one array of full-size urls; falls back to the hero alone for single-image products
    const fulls = thumbs.length ? thumbs.map(t => t.dataset.full) : [hero.dataset.full];
    let cur = 0;

    thumbs.forEach(b => b.addEventListener("click", () => {
      hero.src = b.dataset.src;
      hero.removeAttribute("srcset");          // swapped image is one size; srcset would fight it
      hero.dataset.full = b.dataset.full;
      cur = +b.dataset.index || 0;
      thumbs.forEach(x => x.classList.toggle("is-on", x === b));
    }));

    const lb = $("#lightbox"), lbImg = $("#lbImg"), stage = $("#lbStage"),
          prev = $("#lbPrev"), next = $("#lbNext"), count = $("#lbCount");
    if (lb) {
      const paint = () => {
        lbImg.src = fulls[cur];
        stage.classList.remove("is-zoomed");
        stage.scrollTo(0, 0);
        prev.disabled = cur === 0;
        next.disabled = cur === fulls.length - 1;
        count.textContent = fulls.length > 1 ? `${cur + 1} / ${fulls.length}` : "";
        thumbs.forEach((x, i) => x.classList.toggle("is-on", i === cur));
        if (thumbs[cur]) { hero.src = thumbs[cur].dataset.src; hero.removeAttribute("srcset"); }
      };
      const open = () => { lb.hidden = false; document.body.classList.add("lb-open"); paint(); requestAnimationFrame(() => lb.classList.add("show")); $("#lbClose").focus(); };
      const close = () => { lb.classList.remove("show"); document.body.classList.remove("lb-open"); setTimeout(() => { lb.hidden = true; }, 220); $("#pdpHeroBtn")?.focus(); };
      const step = d => { cur = Math.min(Math.max(cur + d, 0), fulls.length - 1); paint(); };

      $("#pdpHeroBtn")?.addEventListener("click", open);
      $("#lbClose").addEventListener("click", close);
      prev.addEventListener("click", () => step(-1));
      next.addEventListener("click", () => step(1));
      lb.addEventListener("click", e => { if (e.target === lb || e.target === stage) close(); });
      addEventListener("keydown", e => {
        if (lb.hidden) return;
        if (e.key === "Escape") close();
        if (e.key === "ArrowLeft") step(-1);
        if (e.key === "ArrowRight") step(1);
      });
      // click the photo to toggle a 2x zoom anchored where you clicked; pinch works natively
      lbImg.addEventListener("click", e => {
        const zoomed = stage.classList.toggle("is-zoomed");
        if (zoomed) {
          const r = lbImg.getBoundingClientRect();
          const fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
          requestAnimationFrame(() => stage.scrollTo(
            (stage.scrollWidth - stage.clientWidth) * fx,
            (stage.scrollHeight - stage.clientHeight) * fy));
        }
      });
      // swipe between photos on touch
      let tx = 0, ty = 0;
      stage.addEventListener("touchstart", e => { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener("touchend", e => {
        if (stage.classList.contains("is-zoomed")) return;
        const dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
        if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
  }

  /* ---------- mobile sticky add-to-cart ---------- */
  const sticky = $("#pdpSticky"), mainCta = $(".pdp-cta");
  if (sticky && mainCta) {
    const addBtn = $("#pdpAdd"), priceEl = $("#pdpPrice"),
          sAdd = $("#pdpStickyAdd"), sPrice = $("#pdpStickyPrice");
    // mirror price + button state whenever the variant picker changes them
    const mirror = () => {
      if (priceEl && sPrice) sPrice.textContent = priceEl.textContent;
      if (addBtn && sAdd) {
        sAdd.innerHTML = addBtn.innerHTML;               // carries the checkmark through
        sAdd.disabled = addBtn.disabled;
        sAdd.classList.toggle("is-added", addBtn.classList.contains("is-added"));
        sAdd.classList.toggle("is-adding", addBtn.classList.contains("is-adding"));
      }
    };
    mirror();
    new MutationObserver(mirror).observe(addBtn, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ["disabled", "class"] });
    if (priceEl) new MutationObserver(mirror).observe(priceEl, { childList: true, characterData: true, subtree: true });
    // show only after the real button has scrolled above the viewport
    new IntersectionObserver(([en]) => {
      const passed = !en.isIntersecting && en.boundingClientRect.top < 0;
      sticky.hidden = false;
      sticky.classList.toggle("show", passed);
      sticky.setAttribute("aria-hidden", String(!passed));
    }, { threshold: 0 }).observe(mainCta);
  }

  /* ---------- product variant picker ---------- */
  const vJson = $("#pdpVariants");
  if (vJson) {
    let VARIANTS = [];
    try { VARIANTS = JSON.parse(vJson.textContent); } catch { VARIANTS = []; }
    const idField = $("#pdpVariantId"), addBtn = $("#pdpAdd"),
          priceEl = $("#pdpPrice"), warn = $("#optWarn");

    /* Each rendered group knows which Shopify option slot it is
       (option1/2/3), so matching is an exact lookup. Groups with only one
       value aren't rendered and don't need matching. */
    const chosen = () => {
      const sel = {};
      $$("#pdpOptions .opt").forEach(fs => {
        const hit = $("input:checked", fs);
        if (hit) sel[fs.dataset.index] = hit.value;
      });
      return sel;
    };

    const money = cents => {
      const n = cents / 100;
      return "$" + n.toLocaleString("en-US", { maximumFractionDigits: n % 1 ? 2 : 0 });
    };

    function apply() {
      const sel = chosen();
      const match = VARIANTS.find(v => Object.keys(sel).every(k => v[k] === sel[k]));

      if (!match) {
        if (warn) warn.hidden = false;
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = "Unavailable"; }
        return;
      }
      if (warn) warn.hidden = true;
      if (idField) idField.value = match.id;
      if (priceEl && typeof match.price === "number") priceEl.textContent = money(match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? "Add to cart" : "Sold out";
      }
      const u = new URL(location);
      u.searchParams.set("variant", match.id);
      history.replaceState({}, "", u);
    }

    $$("#pdpOptions input").forEach(i => i.addEventListener("change", apply));
    apply();
  }

  /* ---------- add to cart from a grid card (AJAX, keeps you on the page) ---------- */
  /* ---------- add to cart: cards and product page, one path ----------
     Both go through /cart/add.js so the page never reloads, and the button
     the shopper pressed morphs into a checkmark + "Added to cart", then
     restores itself. "Buy it now" is left alone so it still goes to checkout. */
  const CHECK = `<svg class="added-mark" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M4 12.5l5 5L20 6.5" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  function markAdded(btn, label = "Added to cart") {
    if (!btn || btn.dataset.adding === "1") return;
    btn.dataset.adding = "1";
    btn.dataset.orig = btn.innerHTML;
    btn.dataset.origDisabled = btn.disabled ? "1" : "";
    btn.disabled = true;
    btn.classList.add("is-added");
    btn.innerHTML = CHECK + `<span class="added-txt">${label}</span>`;
    setTimeout(() => {
      btn.classList.remove("is-added");
      btn.innerHTML = btn.dataset.orig;
      btn.disabled = btn.dataset.origDisabled === "1";
      delete btn.dataset.adding; delete btn.dataset.orig; delete btn.dataset.origDisabled;
    }, 2200);
  }
  async function refreshCartCount() {
    try {
      const c = await (await fetch("/cart.js", { headers: { Accept: "application/json" } })).json();
      const dot = $("#cartCount");
      if (dot) dot.textContent = c.item_count;
    } catch {}
  }
  document.addEventListener("submit", async e => {
    const form = e.target.closest(".card-add, #pdpForm");
    if (!form) return;
    const submitter = e.submitter || document.activeElement;
    if (submitter && submitter.name === "checkout") return;      // Buy it now -> native, straight to checkout
    e.preventDefault();
    // on the product page always morph the main button; the sticky bar mirrors it
    const btn = form.id === "pdpForm" ? $("#pdpAdd") : (submitter?.matches?.("button") ? submitter : form.querySelector("button[type=submit]"));
    const idEl = form.querySelector("[name=id]");
    if (!idEl || !idEl.value) { toast("Pick a size first"); return; }
    if (btn) btn.classList.add("is-adding");
    try {
      const res = await fetch(CFG.routes.cartAdd, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: idEl.value, quantity: 1 })
      });
      if (!res.ok) throw new Error();
      btn?.classList.remove("is-adding");
      markAdded(btn);
      refreshCartCount();
    } catch {
      btn?.classList.remove("is-adding");
      toast("Could not add — try again");
    }
  });

  /* ---------- collection: load every product, then build the type chips ----------
     Server renders page 1; the rest are fetched and appended so the shopper
     never presses "load more". Chips are derived from the cards that actually
     arrived, so a chip can never point at nothing. */
  const collGrid = $("#collGrid");
  if (collGrid) {
    const chipRow = $("#typeChips");
    const loadingEl = $("#gridLoading");
    const totalPages = parseInt(collGrid.dataset.totalPages || "1", 10);
    const baseUrl = collGrid.dataset.collectionUrl || location.pathname;
    const sort = collGrid.dataset.sort || "";

    const pageUrl = n => {
      const u = new URL(baseUrl, location.origin);
      u.searchParams.set("page", n);
      if (sort) u.searchParams.set("sort_by", sort);
      return u.toString();
    };

    /* Pages are fetched one after another. A page can be entirely sold out
       (it renders zero cards), so an empty page is not the end of the
       collection. A failed request is retried, and if it still fails the
       shopper gets a retry link instead of a silently short grid. */
    const wait = ms => new Promise(r => setTimeout(r, ms));
    async function fetchPage(n) {
      for (let attempt = 0; attempt < 3; attempt++) {
        try {
          const res = await fetch(pageUrl(n), { credentials: "same-origin" });
          if (res.ok) {
            const doc = new DOMParser().parseFromString(await res.text(), "text/html");
            if (doc.querySelector("#collGrid")) return doc;
          }
        } catch (e) { /* network hiccup: retry */ }
        await wait(700 * (attempt + 1));
      }
      return null;
    }

    function showEmptyIfNone() {
      if ($(".card", collGrid) || $(".empty", collGrid)) return;
      const p = document.createElement("p");
      p.className = "empty";
      p.textContent = "Nothing in stock here right now \u2014 check back after the next drop.";
      collGrid.appendChild(p);
    }

    async function loadRest(from = 2) {
      for (let n = from; n <= totalPages; n++) {
        const doc = await fetchPage(n);
        if (!doc) {
          if (loadingEl) {
            loadingEl.innerHTML = `Some pieces did not load. <button type="button">Try again</button>`;
            loadingEl.querySelector("button").addEventListener("click", () => {
              loadingEl.textContent = "Loading the rest of the collection\u2026";
              loadRest(n).then(buildFilters);
            }, { once: true });
          }
          return;
        }
        // in-stock pieces go ahead of every sold piece already on the page,
        // sold pieces go to the very end, so order holds across pages
        const inStock = document.createDocumentFragment(), sold = document.createDocumentFragment();
        doc.querySelectorAll("#collGrid .card").forEach(c =>
          (c.dataset.sold ? sold : inStock).appendChild(document.importNode(c, true)));
        const firstSold = $(".card[data-sold]", collGrid);
        collGrid.insertBefore(inStock, firstSold);
        collGrid.appendChild(sold);
      }
      if (loadingEl) loadingEl.remove();
      collGrid.dataset.loaded = "true";
      showEmptyIfNone();
    }

    /* Safari can restore a page from its back/forward cache mid-load, frozen
       with only the first page of cards. Reload it so the loader runs again. */
    addEventListener("pageshow", e => {
      if (e.persisted && totalPages > 1 && collGrid.dataset.loaded !== "true") location.reload();
    });

    /* ----- size buckets -----
       Listings spell sizes many different ways: "Large", "L", "Extra Large",
       "X-Large (Fits M)", waist "32", shoe "10.5", "43 (10U.S)", "50 (Medium)".
       Each raw value is mapped to one or more canonical buckets so the filter
       offers a short, sane list instead of 58 near-duplicates. */
    const LETTERS = ["XXS", "XS", "S", "M", "L", "XL", "2XL", "3XL", "OS"];
    const LETTER_MAP = {
      xxs: "XXS", xxsmall: "XXS",
      xs: "XS", xsmall: "XS", extrasmall: "XS",
      s: "S", small: "S",
      m: "M", medium: "M", med: "M",
      l: "L", large: "L", lg: "L",
      xl: "XL", xlarge: "XL", extralarge: "XL",
      xxl: "2XL", "2xl": "2XL", xxlarge: "2XL",
      xxxl: "3XL", "3xl": "3XL",
      os: "OS", onesize: "OS", osfa: "OS", onesizefitsall: "OS"
    };
    const letterOf = txt => LETTER_MAP[String(txt).toLowerCase().replace(/[^a-z0-9]/g, "")] || "";

    /* Numeric sizes are ambiguous on their own: 42 could be a waist, a shoe, or
       a varsity jacket. The option name settles it when the merchant used one
       ("Shoe size"), the collection settles it next, and the title is the last
       resort for pieces that have not been filed into a type collection yet. */
    const SHOE_WORDS = /\b(shoe|sneaker|trainer|boot|mule|sandal|slide|loafer|derby|oxford|runner|geobasket|ramones|luxor|jordan|dunk|air force|forum|samba|campus)\b/i;
    const BOTTOM_WORDS = /\b(jean|denim|pant|trouser|shorts|cargo|sweatpant|chino|legging|skirt)\b|\bshort\b(?!\s*sleeve)/i;
    const JACKET_WORDS = /\b(jacket|coat|anorak|windbreaker|varsity|parka|bomber|puffer|blazer|giubbotto|vest)\b/i;

    function kindOf(card, types) {
      const name = card.dataset.sizeName || "";
      const title = ($(".card-title", card) || {}).textContent || "";
      if (name.includes("shoe")) return "shoe";
      if (types.includes("shoes")) return "shoe";
      if (SHOE_WORDS.test(title)) return "shoe";
      if (types.includes("bottoms") || BOTTOM_WORDS.test(title)) return "waist";
      if (types.includes("outerwear") || JACKET_WORDS.test(title)) return "jacket";
      return "";
    }

    function bucketsFor(raw, kind) {
      const val = String(raw).trim();
      if (!val) return [];
      const out = new Set();
      const paren = val.match(/\(([^)]*)\)/);
      const inner = paren ? paren[1] : "";
      const outer = val.replace(/\([^)]*\)/g, " ").trim();

      // a letter size anywhere, including "(Fits Large)" and "50 (Medium)"
      [outer, inner].forEach(part => {
        part.split(/[\/,]|\bfits\b|\bor\b/i).forEach(piece => {
          const L = letterOf(piece.replace(/\bfits\b/i, ""));
          if (L) out.add(L);
        });
      });

      // "43 (10U.S)", "8LV (9.5US)", "47 (US 14)", "40(US 7)" all state the US size
      const us = val.match(/(\d+(?:\.\d+)?)\s*u\.?\s?s\.?/i) || val.match(/u\.?\s?s\.?\s*(\d+(?:\.\d+)?)/i);
      if (kind === "shoe" && us) out.add("US " + parseFloat(us[1]));

      // when the listing spells out a letter size ("44 (Fits Large)", "50 (Medium)")
      // that letter is what the shopper searches by; the number is brand sizing
      const nums = out.size ? [] : (outer.match(/\d+(?:\.\d+)?/g) || []);
      nums.forEach(n => {
        const num = parseFloat(n);
        if (kind === "shoe") {
          if (!us) out.add(num <= 17 ? "US " + num : "EU " + num);
        } else if (kind === "waist" && num >= 20 && num <= 60) {
          out.add("W" + num);
        } else if (kind === "jacket" && !out.size) {
          out.add("EU" + num);                 // varsity and outerwear numbering
        } else if (!out.size) {
          out.add(String(num));                // rare sizing, still filterable
        }
      });
      return [...out];
    }

    const GROUPS = [
      { key: "letter", label: "Clothing", test: b => LETTERS.includes(b),
        rank: b => LETTERS.indexOf(b) },
      { key: "waist", label: "Waist", test: b => /^W\d/.test(b),
        rank: b => parseFloat(b.slice(1)) },
      { key: "shoe", label: "Shoe", test: b => /^(US|EU) /.test(b),
        rank: b => (b.startsWith("EU") ? 1000 : 0) + parseFloat(b.slice(3)) },
      { key: "jacket", label: "Jacket", test: b => /^EU\d/.test(b),
        rank: b => parseFloat(b.slice(2)) },
      { key: "other", label: "Other", test: () => true,
        rank: b => parseFloat(b) || 0 }
    ];
    const groupOf = b => GROUPS.find(g => g.test(b));
    const sizeLabel = b => {
      if (/^W\d/.test(b)) return b.slice(1);
      if (/^EU\d/.test(b)) {                 // brand scales (Moncler 0-6) are not EU numbers
        const n = parseFloat(b.slice(2));
        return n < 20 ? String(n) : "EU " + n;
      }
      return b;
    };

    /* every card gets its buckets once, cached on the element */
    function indexCard(card) {
      if (card.dataset.sizeKeys != null) return;
      const types = (card.dataset.types || "").split(/\s+/).filter(Boolean);
      const raws = (card.dataset.sizes || "").split("|").map(x => x.trim()).filter(Boolean);
      const kind = kindOf(card, types);
      const keys = new Set();
      raws.forEach(r => bucketsFor(r, kind).forEach(b => keys.add(b)));
      card.dataset.sizeKeys = [...keys].join("|");
    }

    let wantType = "all", wantSize = "all";

    /* one chip per item type present in the loaded cards, in theme-settings order */
    function buildChips() {
      if (!chipRow) return;
      // present types, but ordered by the theme setting rather than by whichever
      // product happened to load first
      const present = new Set();
      $$(".card", collGrid).forEach(card =>
        (card.dataset.types || "").split(/\s+/).filter(Boolean).forEach(t => present.add(t)));

      const settingOrder = (chipRow.dataset.order || "").split(",").map(x => x.trim()).filter(Boolean);
      const titles = {};
      (chipRow.dataset.titles || "").split("|").forEach(pair => {
        const i = pair.indexOf(":");
        if (i > 0) titles[pair.slice(0, i)] = pair.slice(i + 1);
      });
      const order = settingOrder.filter(h => present.has(h))
        .concat([...present].filter(h => !settingOrder.includes(h)));
      const label = h => titles[h] || h.replace(/-/g, " ").replace(/\b\w/g, m => m.toUpperCase());
      chipRow.innerHTML =
        `<button class="chip" type="button" data-filter="all" aria-pressed="true">All</button>` +
        order.map(t => `<button class="chip" type="button" data-filter="${t}" aria-pressed="false">${label(t)}</button>`).join("");
    }

    /* the size menu lists only sizes in stock, counted against the type in view */
    function buildSizes() {
      const dd = $("#sizeFilter");
      if (!dd) return;
      const menu = $(".dd-menu", dd);
      const counts = new Map();
      $$(".card", collGrid).forEach(card => {
        indexCard(card);
        if (!matchesType(card)) return;
        (card.dataset.sizeKeys || "").split("|").filter(Boolean)
          .forEach(k => counts.set(k, (counts.get(k) || 0) + 1));
      });

      if (counts.size < 2) { dd.hidden = true; return; }   // nothing worth filtering
      dd.hidden = false;

      let html = `<li role="option" data-size="all"${wantSize === "all" ? ' class="is-on"' : ""}>All sizes</li>`;
      GROUPS.forEach(g => {
        const keys = [...counts.keys()].filter(k => groupOf(k) === g).sort((a, b) => g.rank(a) - g.rank(b));
        if (!keys.length) return;
        if (GROUPS.filter(x => [...counts.keys()].some(k => groupOf(k) === x)).length > 1) {
          html += `<li class="dd-group" aria-hidden="true">${g.label}</li>`;
        }
        keys.forEach(k => {
          html += `<li role="option" data-size="${k}"${wantSize === k ? ' class="is-on"' : ""}>` +
                  `${sizeLabel(k)} <b>${counts.get(k)}</b></li>`;
        });
      });
      menu.innerHTML = html;
      $(".dd-current", dd).textContent = wantSize === "all" ? "All sizes" : sizeLabel(wantSize);
    }

    const matchesType = card => wantType === "all" ||
      (card.dataset.types || "").split(/\s+/).includes(wantType);
    const matchesSize = card => wantSize === "all" ||
      (card.dataset.sizeKeys || "").split("|").includes(wantSize);

    function applyFilters() {
      let shown = 0;
      $$(".card", collGrid).forEach(card => {
        indexCard(card);
        const on = matchesType(card) && matchesSize(card);
        card.hidden = !on;
        if (on) shown++;
      });
      let msg = $("#filterEmpty");
      if (!shown) {
        if (!msg) {
          msg = document.createElement("p");
          msg.id = "filterEmpty";
          msg.className = "empty";
          collGrid.appendChild(msg);
        }
        msg.textContent = wantSize === "all"
          ? "Nothing of that type in stock right now."
          : "Nothing in that size in stock right now.";
        msg.hidden = false;
      } else if (msg) msg.hidden = true;
    }

    chipRow?.addEventListener("click", e => {
      const btn = e.target.closest("[data-filter]");
      if (!btn) return;
      wantType = btn.dataset.filter;
      $$("[data-filter]", chipRow).forEach(b => b.setAttribute("aria-pressed", String(b === btn)));
      // a size can exist under one type and not another, so re-offer and re-check
      const dd = $("#sizeFilter");
      const stillThere = () => $$(".card", collGrid).some(c => matchesType(c) && matchesSize(c));
      if (wantSize !== "all" && !stillThere()) wantSize = "all";
      buildSizes();
      applyFilters();
      if (dd) dd.dataset.open = "false";
    });

    $("#sizeFilter")?.addEventListener("click", e => {
      const li = e.target.closest("[data-size]");
      if (!li) return;
      wantSize = li.dataset.size;
      buildSizes();
      applyFilters();
    });

    function buildFilters() { buildChips(); buildSizes(); applyFilters(); }

    if (totalPages > 1) loadRest().then(buildFilters);
    else { collGrid.dataset.loaded = "true"; showEmptyIfNone(); buildFilters(); }
  }

  /* ---------- reveal on scroll ---------- */
  const io = new IntersectionObserver(en => en.forEach(x => {
    if (x.isIntersecting) { x.target.classList.add("in"); io.unobserve(x.target); }
  }), { threshold: 0.1, rootMargin: "0px 0px -6% 0px" });
  $$(".rev").forEach(el => io.observe(el));


  /* ---------- Sell to Us: stage photos, hand them to mail or DM ---------- */
  /* ---------- sell form: reveal the free-text brand field for "Other" ---------- */
  const brandSel = $("#sBrand"), otherField = $("#otherBrandField"), otherInput = $("#sOther");
  if (brandSel && otherField) {
    const syncOther = (focus) => {
      const isOther = brandSel.value === "Other";
      otherField.hidden = !isOther;
      if (otherInput) {
        otherInput.required = isOther;
        if (!isOther) otherInput.value = "";
        else if (focus) otherInput.focus();
      }
    };
    brandSel.addEventListener("change", () => syncOther(true));
    syncOther(false);   // honour a browser-restored selection on reload
  }

  const photoInput = $("#sPhotos");
  if (photoInput) {
    const list = $("#fileList"), panel = $("#sendPhotos"), countEl = $("#photoCount");
    let picked = [];
    const size = n => n < 1048576 ? Math.round(n / 1024) + " KB" : (n / 1048576).toFixed(1) + " MB";

    function paint() {
      list.innerHTML = picked.map((f, i) => `
        <li><span class="fl-name">${f.name}</span><span class="fl-size">${size(f.size)}</span>
        <button type="button" class="fl-x" data-i="${i}" aria-label="Remove ${f.name}">&times;</button></li>`).join("");
      $("#pickPhotos").textContent = picked.length ? `Add more (${picked.length} selected)` : "Choose photos";
      panel.hidden = picked.length === 0;
      if (picked.length) countEl.textContent = picked.length + (picked.length === 1 ? " photo" : " photos");
      const v = id => ($(id)?.value || "").trim();
      const brand = v("#sOther") || v("#sBrand");
      const body = [
        "Item: " + (brand || "(brand)"),
        "Condition: " + v("#sCond"),
        "Details: " + (v("#sDetails") || "(none given)"),
        "From: " + v("#sName") + " " + v("#sEmail"),
        "", "Photos attached: " + picked.length, "", picked.map(f => "- " + f.name).join("\n")
      ].join("\n");
      $("#emailPhotos").href = "mailto:rehypednyc@gmail.com"
        + "?subject=" + encodeURIComponent("Sell to Us - " + (brand || "submission"))
        + "&body=" + encodeURIComponent(body);
    }

    $("#pickPhotos").addEventListener("click", () => photoInput.click());
    photoInput.addEventListener("change", () => {
      picked = picked.concat([...photoInput.files]);   // append so repeat picks accumulate
      photoInput.value = "";
      paint();
    });
    list.addEventListener("click", e => {
      const b = e.target.closest("[data-i]");
      if (!b) return;
      picked.splice(+b.dataset.i, 1);
      paint();
    });
    ["#sName", "#sEmail", "#sBrand", "#sCond", "#sDetails", "#sOther"].forEach(sel =>
      $(sel)?.addEventListener("input", () => { if (picked.length) paint(); }));
  }

  /* ============================================================
     Blackjack popup — settings come from the section's data-attributes
     ============================================================ */
  const mount = $("#bjMount");
  if (mount && !localStorage.getItem("rhGameDone")) (function(){
    const D = mount.dataset;
    const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
      const wait = ms => new Promise(r => setTimeout(r, reduce ? 0 : ms));
    
      const SUITS = ["♠","♥","♦","♣"];
      const RANKS = ["A","2","3","4","5","6","7","8","9","10","J","Q","K"];
      const rnd = n => Math.floor(Math.random() * n);
      const code = prefix => prefix + "-" +
        Array.from({length:4}, () => "ABCDEFGHJKMNPQRSTUVWXYZ23456789"[rnd(30)]).join("");
    
      let deck, you, dealer, over, busy = false, replays = 0;
    
      const build = () => {
        deck = [];
        for (const s of SUITS) for (const r of RANKS) deck.push({ r, s });
        for (let i = deck.length - 1; i > 0; i--){          // Fisher-Yates
          const j = rnd(i + 1); [deck[i], deck[j]] = [deck[j], deck[i]];
        }
      };
      const draw = () => deck.pop();
      const total = hand => {
        let t = 0, aces = 0;
        for (const c of hand){
          if (c.r === "A"){ t += 11; aces++; }
          else t += ["J","Q","K"].includes(c.r) ? 10 : +c.r;
        }
        while (t > 21 && aces){ t -= 10; aces--; }
        return t;
      };
    
      /* ---------- shell ---------- */
      const el = document.createElement("div");
      el.className = "bj-overlay";
      el.innerHTML = `
        <div class="bj" role="dialog" aria-modal="true" aria-label="Play a hand">
          <div class="bj-head">
            <img class="bj-logo" src="${D.logo}" alt="${D.shop}">
            <button class="bj-x" aria-label="Close">&times;</button>
          </div>
          <div class="bj-body"></div>
        </div>`;
      document.body.appendChild(el);
      const body = $(".bj-body", el);
    
      const done = () => { try { localStorage.setItem("rhGameDone", "1"); } catch (e) {} };
      const close = () => {
        el.classList.add("is-closing");
        el.classList.remove("show");
        done();
        setTimeout(() => el.remove(), 320);
      };
      $(".bj-x", el).addEventListener("click", close);
      el.addEventListener("click", e => { if (e.target === el) close(); });
      addEventListener("keydown", e => { if (e.key === "Escape" && el.isConnected) close(); });
    
      /* ---------- table: built once, then mutated ----------
         Cards are appended one at a time so a Hit never re-renders the
         cards already on the table — that re-render was the flicker.     */
      const face = c => `<b>${c.r}</b><i>${c.s}</i>`;
      const isRed = c => c.s === "♥" || c.s === "♦";
    
      function tableShell(){
        body.innerHTML = `
          <p class="bj-kicker">Beat the dealer &mdash; win <b>${D.winLabel}</b></p>
          <div class="bj-row">
            <span class="bj-who">Dealer</span>
            <span class="bj-cards" data-hand="dealer"></span>
            <span class="bj-score" data-score="dealer"></span>
          </div>
          <div class="bj-row is-you">
            <span class="bj-who">You</span>
            <span class="bj-cards" data-hand="you"></span>
            <span class="bj-score" data-score="you"></span>
          </div>
          <div class="bj-actions">
            <button class="btn btn-light" data-act="hit">Hit</button>
            <button class="btn btn-ghost" data-act="stand">Stand</button>
          </div>`;
      }
      const hand  = w => $(`[data-hand="${w}"]`, body);
      const score = w => $(`[data-score="${w}"]`, body);
    
      function setScore(w, val){
        const e = score(w);
        if (!e || e.textContent === String(val)) return;
        e.textContent = val;
        e.classList.remove("bump"); void e.offsetWidth; e.classList.add("bump");
      }
      function lockControls(on){
        busy = on;
        $$("[data-act]", body).forEach(b => b.disabled = on);
      }
    
      async function place(who, card, hidden){
        const s = document.createElement("span");
        s.className = "bj-card is-dealing" + (hidden ? " is-back" : (isRed(card) ? " is-red" : ""));
        if (!hidden) s.innerHTML = face(card);
        hand(who).appendChild(s);
        void s.offsetWidth;
        s.classList.remove("is-dealing");
        await wait(170);
      }
    
      async function flipHole(){
        const c = hand("dealer").children[1];
        if (!c) return;
        c.classList.add("is-flipping");
        await wait(170);                       // edge-on, swap the face here
        c.classList.remove("is-back");
        if (isRed(dealer[1])) c.classList.add("is-red");
        c.innerHTML = face(dealer[1]);
        await wait(190);
        c.classList.remove("is-flipping");
      }
    
      /* Content goes in first, then animates in. Never hide the panel behind a
         pending timer — a delayed timer would leave the user staring at a blank box. */
      function swapBody(html){
        body.innerHTML = html;
        body.scrollTop = 0;
        if (reduce) return;
        body.classList.add("is-entering");
        void body.offsetWidth;
        body.classList.remove("is-entering");
      }
    
      /* ---------- rounds ---------- */
      async function deal(){
        build(); you = []; dealer = []; over = false;
        tableShell();
        lockControls(true);
        await wait(120);
        await place("you", you[you.push(draw()) - 1]);            setScore("you", total(you));
        await place("dealer", dealer[dealer.push(draw()) - 1]);   setScore("dealer", total(dealer));
        await place("you", you[you.push(draw()) - 1]);            setScore("you", total(you));
        await place("dealer", dealer[dealer.push(draw()) - 1], true);
        lockControls(false);
      }
    
      async function hit(){
        if (busy || over) return;
        lockControls(true);
        await place("you", you[you.push(draw()) - 1]);
        setScore("you", total(you));
        if (total(you) > 21){ over = true; await wait(420); return lose(); }
        lockControls(false);
      }
    
      async function stand(){
        if (busy || over) return;
        over = true;
        lockControls(true);
        await flipHole();
        setScore("dealer", total(dealer));
        while (total(dealer) < 17){
          await wait(260);
          await place("dealer", dealer[dealer.push(draw()) - 1]);
          setScore("dealer", total(dealer));
        }
        await wait(480);
        (total(dealer) > 21 || total(you) > total(dealer)) ? win() : lose();
      }
    

      /* Prize headline first, code beneath. An unconfigured code shows a real
         fallback instead of an empty box. */
      function payout(headline, label, c, note){
        return `
          <p class="bj-result is-win">${headline}</p>
          <p class="bj-prize">${label}</p>
          <div class="bj-code"><b>${c}</b><button class="bj-copy" data-copy="${c}">Copy</button></div>
          <p class="bj-terms">Enter this at checkout. One use per customer.${note ? " " + note : ""}</p>
          <div class="bj-actions"><a class="btn btn-light" href="${D.shopUrl}" style="flex:1">Start shopping <span class="arw">&rarr;</span></a></div>`;
      }
      function win(){
        swapBody(payout("You beat the dealer", D.winLabel, D.winCode || "", ""));
        done();
      }

      function lose(){
        const canReplay = replays < ((+D.replays || 0));
        swapBody(`
          <p class="bj-result is-lose">Dealer edges it</p>
          <p class="bj-sub">The house took the hand, you still take the gift.</p>
    
          <form class="bj-form" data-kind="email">
            <label for="bjEmail">Claim ${D.winLabel}</label>
            <div class="bj-inline">
              <input id="bjEmail" type="email" placeholder="you@email.com" required>
              <button class="btn btn-light" type="submit">Claim</button>
            </div>
            <p class="bj-consent">By claiming you agree to receive email marketing from ${D.shop}. Drops &amp; restocks only &mdash; no spam, unsubscribe anytime.</p>
          </form>
    
          <details class="bj-dd">
            <summary>Double down<span class="bj-dd-tag">${D.smsLabel}</span></summary>
            <form class="bj-form" data-kind="sms">
              <div class="bj-inline">
                <input id="bjPhone" type="tel" placeholder="(555) 555-5555" required>
                <button class="btn btn-light" type="submit">Deal me in</button>
              </div>
              <p class="bj-consent">By entering your number you agree to receive recurring automated marketing texts from ${D.shop} at the number provided. Consent is not a condition of purchase. Msg &amp; data rates may apply. Reply STOP to opt out, HELP for help.</p>
            </form>
          </details>
    
          <div class="bj-links">
            ${canReplay ? `<button class="bj-link" data-act2="again">Deal again</button>` : `<span class="bj-spent">No hands left</span>`}
            <button class="bj-link is-quiet" data-act2="nah">Nah, I'm good</button>
          </div>`);
      }
    
      /* ---------- one delegated listener for the whole panel ---------- */
      body.addEventListener("click", e => {
        const act = e.target.closest("[data-act]");
        if (act) return act.dataset.act === "hit" ? hit() : stand();
    
        const again = e.target.closest("[data-act2]");
        if (again) return again.dataset.act2 === "again" ? (replays++, deal()) : close();
    
        const cp = e.target.closest("[data-copy]");
        if (cp){
          navigator.clipboard?.writeText(cp.dataset.copy);
          cp.textContent = "Copied";
          setTimeout(() => { cp.textContent = "Copy"; }, 1600);
        }
      });
    
      body.addEventListener("submit", e => {
        e.preventDefault();
        const isSms = e.target.dataset.kind === "sms";
        const c = (isSms ? D.smsCode : D.winCode) || "";
        const label = isSms ? D.smsLabel : D.winLabel;
        swapBody(payout(isSms ? "Double down paid" : "Code unlocked", label, c, ""));
        done();
      });
    
      /* ---------- trigger: whichever comes first ---------- */
      let fired = false;
      const open = () => {
        if (fired) return;
        fired = true;
        removeEventListener("scroll", onScroll);
        clearTimeout(timer);
        deal();
        void el.offsetWidth;          // force reflow so the transition plays
        el.classList.add("show");
      };
      const onScroll = () => {
        const max = document.documentElement.scrollHeight - innerHeight;
        if (max > 0 && scrollY / max >= (parseFloat(D.scroll || 0.18))) open();
      };
      const timer = setTimeout(open, +D.time || 4500);
      addEventListener("scroll", onScroll, { passive:true });
      onScroll();
  })();
})();
